import { render, staticRenderFns } from "./IconSoundWave.vue?vue&type=template&id=e07c2036"
import script from "./IconSoundWave.vue?vue&type=script&lang=js"
export * from "./IconSoundWave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports